import Vue from 'vue';
import vSelect from 'vue-select';

// for style imports please see index.scss

Vue.component('v-select', vSelect);
